import axios from '@/libs/api.request'

//   获取订单列表
export const getfoodOrderList = (data) => {
    return axios.request({
      url: 'foodorder/page',
      data: data,
      method: 'post',
    })
}

// 修改订单状态
export const updateordertype = (data) => {
    return axios.request({
      url: 'foodorder/updateordertype',
      data: data,
      method: 'post',
    })
}

// 管理端：确认订单
export const adminConfirmFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/confirm',
    data,
    method: 'post',
  })
}

// 管理端：备货完成
export const adminPickingDoneFoodOrder = (data) => {
  return axios.request({
    url: 'foodorder/admin/picking-done',
    data,
    method: 'post',
  })
}